<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>
    <v-sheet color="backgroundGrayColor" class="py-16" height="auto" style="border: solid rgb(220, 220, 220);">
      <v-container class="mx-auto" style="max-width: 1100px;">
        <p class="font-weight-bold">5月からのコロナ5類引き下げに伴い、行動指針をアップデートします。再度、マスク着用・行動に関して確認をお願いします。<br>
          医療関係者同様に皆も健康第一で過ごしつつ、社会に貢献し続けよう</p>
        <v-img src="@/assets/guidelinesForAction/guideline_1.png"></v-img>
        <v-img src="@/assets/guidelinesForAction/guideline_2.png"></v-img>
        <v-img src="@/assets/guidelinesForAction/guideline_3.png"></v-img>
        <v-img src="@/assets/guidelinesForAction/guideline_4.png"></v-img>
        <v-img src="@/assets/guidelinesForAction/guideline_5.png"></v-img>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import Title from '../components/Title';

export default {
  name: 'GuidelinesForActionView',
  components: {
    Title,
  },
  data() {
    return {
      title: '行動指針',
      img: 'title_undraw_a_day_off_re_hedl.svg',
    };
  },
};
</script>

<style scoped lang="scss">
</style>
